import React from 'react';
import Header from '@/modules/dashboard/components/Header';
import JobsSummary from '@/modules/dashboard/components/JobsSummary';
import TodaysJobsTable from '@/modules/dashboard/components/TodaysJobsTable';
import TimesheetDisputesTable from '@/modules/dashboard/components/TimesheetDisputesTable';
import UnfilledJobsTable from '@/modules/dashboard/components/UnfilledJobsTable';
import NoJobsSection from '@/modules/dashboard/components/NoJobsSection';
import useFeatureView from '@/hooks/useFeatureView';
import { useDashboardData } from '@/modules/dashboard/hooks/useDashboardData';
import { getDashboardView } from '@/modules/dashboard/views/dashboard.view';

const DashboardPage = () => {
  const view = useFeatureView(getDashboardView);
  const {
    isLoading,
    jobs,
    timeframeStartDate,
    timeframeEndDate,
    handleDateChange,
    refreshData,
    filledJobs,
    timeframeUnfilledJobs,
    unfilledJobs,
    disputedTimesheets,
    todaysShifts,
  } = useDashboardData(view);

  const { widgets } = view;
  const showActionTables =
    (widgets.showTimesheetDisputes || widgets.showUnfilledJobs) &&
    (unfilledJobs.length > 0 || disputedTimesheets.length > 0);

  return (
    <div className="min-h-screen bg-gray-100 p-4 sm:p-8">
      {widgets.showHeader && (
        <Header
          startDate={timeframeStartDate}
          endDate={timeframeEndDate}
          handleDateChange={handleDateChange}
          refreshData={refreshData}
        />
      )}
      {widgets.showJobsSummary && (
        <JobsSummary
          jobs={jobs}
          filledJobs={filledJobs}
          unfilledJobs={timeframeUnfilledJobs}
          timeframeStartDate={timeframeStartDate}
          timeframeEndDate={timeframeEndDate}
        />
      )}
      {widgets.showTodaysJobs && (
        <TodaysJobsTable todaysShifts={todaysShifts} isLoading={isLoading} />
      )}
      {showActionTables ? (
        <div className="mb-4 grid grid-cols-1 gap-4 xl:grid-cols-2">
          {widgets.showUnfilledJobs && (
            <UnfilledJobsTable
              allFilteredJobs={unfilledJobs}
              timeframeStartDate={timeframeStartDate}
              timeframeEndDate={timeframeEndDate}
              isLoading={isLoading}
            />
          )}
          {widgets.showTimesheetDisputes && (
            <TimesheetDisputesTable disputedTimesheets={disputedTimesheets} />
          )}
        </div>
      ) : (
        widgets.showNoJobsSection && <NoJobsSection />
      )}
    </div>
  );
};

export default DashboardPage;
